import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { useFileValidationRules } from 'utils/hooks/useFileHandling';
import { UPLOAD_DOCUMENT_MUTATION } from '../mutations';

export function useFileUpload({ onStarting = _ => {}, onError = _ => {}, onCompleted = _ => {} } = {}) {
  const { validateFileExtension, validateFileSize } = useFileValidationRules();
  const [uploadFileMutation, { loading: uploading, error, ...rest }] = useMutation(UPLOAD_DOCUMENT_MUTATION, {
    context: {
      headers: { 'Apollo-Require-Preflight': 'true' }
    },
    onError: err => {
      onError(err);
    }
  });

  const uploadFile = useCallback(
    (documentId, siteId, file, formData, documentAttachment) => {
      if (!file) {
        onError();
        return;
      }

      if (!validateFileExtension(file.file) || !validateFileSize(file.file)) {
        onError();
        return;
      }
      onStarting(file);
      uploadFileMutation({
        variables: {
          input: { documentId, siteId, model: { file, ...formData, documentAttachment } }
        },
        onError: err => {
          onError(err);
        },
        onCompleted: response => {
          onCompleted(response);
        }
      });
    },
    [onStarting, validateFileExtension, validateFileSize, uploadFileMutation, onError, onCompleted]
  );

  return [uploadFile, { uploading, error, ...rest }];
}
